import Datepicker from "vanillajs-datepicker/Datepicker";
import de from 'vanillajs-datepicker/locales/de';
import it from 'vanillajs-datepicker/locales/it';

const fr = {
  'fr': {
    days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    daysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Déc"],
    today: "Aujourd'hui",
    monthsTitle: "Mois",
    clear: "Effacer",
    weekStart: 1,
    format: "dd.mm.yyyy",
  },
};

Object.assign(Datepicker.locales, fr, de, it);

class FormDatePicker {
  constructor() {
    this.initAll();
    this.observeDomChanges();
  }

  initAll() {
    const pickers = document.querySelectorAll('.form-date:not(.init)');
    if(pickers.length === 0) return;
    pickers.forEach(picker => this.initPicker(picker));
  }

  initPicker(picker) {
    this.initDatepicker(picker);
    this.initInputRestrictions(picker);
    this.initAutoFormat(picker);
    this.markAsInitialized(picker);
    this.initHover(picker);
  }

  initDatepicker(picker) {
    let lang = document.documentElement.lang || 'fr';
    lang = lang.substring(0, 2).toLowerCase();

    const dp = new Datepicker(picker, {
      format: 'dd.mm.yyyy',
      language: lang,
      autohide: true,
      minDate: '01.01.1900',
      maxDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
    });

    return dp;
  }

  initHover(picker) {
    picker.addEventListener('mouseenter', (e) => {
      e.target.closest('.sk-form__field')?.classList.add('hover');
    });

    picker.addEventListener('mouseleave', (e) => {
      e.target.closest('.sk-form__field')?.classList.remove('hover');
    });
  }

  initInputRestrictions(picker) {
    picker.addEventListener('keypress', (e) => {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
    });
  }

  initAutoFormat(picker) {
    picker.addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, '');

      if (value.length >= 3 && value.length <= 4) {
        value = value.slice(0, 2) + '-' + value.slice(2);
      } else if (value.length > 4) {
        value = value.slice(0, 2) + '-' + value.slice(2, 4) + '-' + value.slice(4, 8);
      }

      e.target.value = value;
    });
  }

  markAsInitialized(picker) {
    picker.classList.add('init');
  }

  observeDomChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.matches('.form-date:not(.init)')) {
                this.initPicker(node);
              } else {
                const nestedPickers = node.querySelectorAll?.('.form-date:not(.init)');
                if (nestedPickers?.length) {
                  this.initAll(node);
                }
              }
            }
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

export default FormDatePicker;
